import * as Yup from "yup";
import { FixedTypeEnum } from "./createContract.enums";

const stripHtml = (value) =>
  String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\u200B/g, "")
    .replace(/\s+/g, " ")
    .trim();

const hasValue = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === "number") return Number.isFinite(value);
  return String(value).trim().length > 0;
};

const fixedTypeValues = Object.values(FixedTypeEnum);

export const createContractSchema = Yup.object().shape({
  templateName: Yup.string().trim().required("Template Name is required"),
  customer: Yup.mixed().test("customer-required", "Customer is required", hasValue),
  status: Yup.string().trim().required("Status is required"),
  vehicleTypes: Yup.array()
    .of(
      Yup.mixed().test("vehicle-type-required", "Vehicle Type is required", hasValue)
    )
    .min(1, "Vehicle Type is required")
    .required("Vehicle Type is required"),
  effectiveFrom: Yup.string().trim().required("Effective From is required"),
  effectiveTo: Yup.string().trim().required("Effective To is required"),
  billingFrequency: Yup.string().trim().required("Billing frequency is required"),
  paymentMethod: Yup.string().trim().required("Payment method is required"),
  paymentTerms: Yup.string().trim().required("Payment terms are required"),
  bank: Yup.string().when("paymentMethod", {
    is: "bank_transfer",
    then: (schema) => schema.required("Bank is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  accountTitle: Yup.string().when("paymentMethod", {
    is: "bank_transfer",
    then: (schema) => schema.required("Account title is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  iban: Yup.string().when("paymentMethod", {
    is: "bank_transfer",
    then: (schema) =>
      schema
        .matches(/^[A-Z0-9]+$/i, "Enter a valid IBAN/account number")
        .required("IBAN/Account number is required"),
    otherwise: (schema) => schema.nullable(),
  }),
  description: Yup.string()
    .nullable()
    .test(
      "description-max",
      "Description is too long",
      (value) => stripHtml(value).length <= 3000
    ),
  attachments: Yup.array().nullable(),
  charges: Yup.array()
    .of(
      Yup.object().shape({
        vehicleType: Yup.string().nullable(),
        vehicleTypeId: Yup.mixed().nullable(),
        variableType: Yup.string().trim().nullable(),
        variableRate: Yup.string()
          .trim()
          .when("variableType", {
            is: (val) => !!val,
            then: (schema) => schema.required("Variable Value is required"),
            otherwise: (schema) => schema.nullable(),
          }),
        numberOfVehicle: Yup.string()
          .trim()
          .required("Number of Vehicle is required"),
        monthlyCharges: Yup.string().trim().nullable(),
        formulaTripData: Yup.string().nullable(),
        formulaTokens: Yup.array().nullable(),
        formulaRules: Yup.array().nullable(),
        fixedCharges: Yup.array()
          .of(
            Yup.object().shape({
              fixedType: Yup.string()
                .trim()
                .oneOf(fixedTypeValues, "Invalid Fixed Type")
                .required("Fixed Type is required"),
              fixedCharge: Yup.string()
                .trim()
                .required("Fixed Charge is required"),
            })
          )
          .nullable(),
      })
    )
    .nullable(),
  notes: Yup.string()
    .nullable()
    .test("notes-max", "Notes are too long", (value) => stripHtml(value).length <= 1500),
});

